import { render, staticRenderFns } from "./DeviceAuthorization.vue?vue&type=template&id=26c726a2&"
import script from "./DeviceAuthorization.vue?vue&type=script&lang=js&"
export * from "./DeviceAuthorization.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports